import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const OrgUnitIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M3.3 2.7c-.3 0-.6.3-.6.6V6c0 .4.3.7.6.7H6c.4 0 .7-.3.7-.7V3.3c0-.3-.3-.6-.7-.6H3.3Zm-2 .6c0-1 1-2 2-2H6a2 2 0 0 1 2 2V6a2 2 0 0 1-2 2H3.3a2 2 0 0 1-2-2V3.3Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M4.7 6.7c.3 0 .6.3.6.6V10a.7.7 0 0 0 .7.7h2.7a.7.7 0 0 1 0 1.3H6a2 2 0 0 1-2-2V7.3c0-.3.3-.6.7-.6Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M10 9.3c-.4 0-.7.3-.7.7v2.7c0 .3.3.6.7.6h2.7c.3 0 .6-.3.6-.6V10c0-.4-.3-.7-.6-.7H10ZM8 10c0-1.1.9-2 2-2h2.7a2 2 0 0 1 2 2v2.7a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V10Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default OrgUnitIcon;
